import {HpoRole, Priority} from "./choices";
import {YesNo, YesNoLabels, UnitType, UnitTypeLabel} from "@/choices";
import dayjs from "dayjs";
import {interpolate, ngettext} from "@/utils/translate";


export function priorityColor(priority) {
    if (!priority) {
        return null;
    }

    if (priority === Priority.IV) {
        return 'black';
    }
    if (priority === Priority.III) {
        return 'green'
    }
    if (priority === Priority.II) {
        return 'yellow'
    }
    return 'red';
}


export function priorityClass(priority) {
    if (priority) {
        return 'hpo-color-field--' + priorityColor(priority);
    }
}

export function unitType(type, unitTypeSpec) {
    if (!type) {
        return null
    }
    if (type === UnitType.OTHER) {
        return unitTypeSpec
    }
    return UnitTypeLabel[type]
}

export function ventilated(value) {
    if (value === YesNo.YES) {
        return YesNoLabels[YesNo.YES]
    } else if (value === YesNo.NO) {
        return YesNoLabels[YesNo.NO]
    }
    return null
}

export function isEmsMember(memberRole) {
    return [HpoRole.ZOS, HpoRole.EVAC_MANAGER, HpoRole.VLS, HpoRole.PHC].includes(memberRole)
}

export function isIzsDispatching(memberRole) {
    return [HpoRole.KOPIS, HpoRole.IOS].includes(memberRole)
}

export function isIzsWorker(memberRole) {
    return [HpoRole.FIREMAN, HpoRole.POLICEMAN].includes(memberRole)
}